$shm_dashboard_admin_book $mol_book2
	section? \users
	section_state_key \admin_section
	auth_state*? \
	auth_pb_url_override? \
	placeholders /
	pages <= admin_pages /
	Menu $mol_page
		title \Администрирование
		body /
			<= Navigation $mol_view
				sub /
					<= Users_link $shm_dashboard_admin_section_link
						arg <= users_arg *
						title \Пользователи
						current <= users_current false
					<= Wordstat_link $shm_dashboard_admin_section_link
						arg <= wordstat_arg *
						title \Wordstat
						current <= wordstat_current false
					<= Monitoring_link $shm_dashboard_admin_section_link
						arg <= monitoring_arg *
						title \Мониторинг упоминаний
						current <= monitoring_current false
					<= Server_link $shm_dashboard_admin_section_link
						arg <= server_arg *
						title \Сервер
						current <= server_current false
		foot /
			<= Menu_session $mol_view
				sub <= menu_session_rows /
			<= Footer $shm_hitalama_footer
				version <= version_data_version \-
				date <= version_data_date \-
	Dashboard_link $mol_link
		uri <= dashboard_url \
		title <= dashboard_url \
		target \_blank
	Superuser $mol_view
		sub / <= superuser_title \
	Logout $mol_button_minor
		title \Выйти
		click? <=> logout? null
	Auth $shm_dashboard_admin_auth
		state*? <=> auth_state*? \
		pb_url_override? <=> auth_pb_url_override? \
	Users $shm_dashboard_admin_users
	Wordstat $shm_dashboard_admin_wordstat
	Monitoring $shm_dashboard_admin_monitoring
	Server $shm_dashboard_admin_server
	Server_charts $shm_dashboard_admin_server_charts
		metric_history <= server_metric_history /

$shm_dashboard_admin_section_link $mol_link
	uri_toggle <= uri
